enum TaxNoticeSearchContractStatus {
  READY = 0,

  SYSTEM = 100,
  USER = 200,
}

export default TaxNoticeSearchContractStatus;
